export type Selector<TState = any, TReturn = any> = (state: TState) => TReturn;
export type SelectorReturn<TState, TReturn> = (state: TState) => TReturn;

export const createSelector = <TState, TReturn, TResult>(
  selector: Selector<TState, TReturn>,
  selectReturn: SelectorReturn<TReturn, TResult>,
) => {
  return (state: TState) => {
    const val = selector(state);
    return selectReturn(val);
  };
};
